
import Vue from 'vue'
export default Vue.extend({
    props: {
        type: String,
        value: {
            type: String,
            required: false,
            default: "text"
        },
        size: Number
    },
    mounted() {
        this.localValue = this.value;
    },
    methods: {
        calcSize() {
            const max = this.type === "number" ? 10 : Number.POSITIVE_INFINITY;
            const res = Math.min(max, Math.max(this.localValue.length + 2, this.size));
            console.log(res);
            return res;
        },
        edit() {
            this.isEditing = true;
        },
        async save() {
            this.isEditing = false;
            this.$emit('input', this.localValue);
        },
        handleBlur(event: FocusEvent) {
            if (event.relatedTarget !== this.$refs.save) {
                this.localValue = this.value;
                this.isEditing = false;
            }
        }
    },
    watch: {
        value(newValue) {
            this.localValue = newValue;
            this.isEditing = false;
        },
        isEditing(newValue) {
            if (newValue) {
                setTimeout(() => (this.$refs.input as HTMLInputElement)?.focus(), 0);
            }
        }
    },
    data() {
        return {
            isEditing: false,
            localValue: ""
        }
    }
})
